/**
 * Get the Google Maps API key from the server.
 *
 * @package
 */

/**
 * WordPress dependencies
 */
import apiFetch from '@wordpress/api-fetch';

/**
 * Get the Google Maps API key from API
 *
 * @return {Promise<string>}	The API key
 */
const getkey = () => {
	return apiFetch< string >( { path: '/stockistmap/v1/key' } );
};

export default getkey;
